
import { mockBackend } from './environment'
import { ScheduleSong } from '../models/song'
import { ScheduleProgram } from '../models/program'
import { Json } from '../models/json'
import axios from 'axios'

export interface Schedule {
  songs: ScheduleSong[];
  programs: ScheduleProgram[];
}

function parseProgram (json: Json): ScheduleProgram {
  return {
    id: 123,
    name: json.title as string,
    start: Date.parse(json.start as string),
    end: Date.parse(json.end as string),
    isCurrent: (json.isCurrent as boolean) ?? false
  }
}

function parseSong (json: Json): ScheduleSong {
  return {
    title: json.title as string,
    artist: json.subtitle as string,
    start: Date.parse(json.start as string),
    cover: json.thumbnail as string,
    isCurrent: (json.isCurrent as boolean) ?? false
  }
}

function parseSchedule (json: Json): Schedule {
  return {
    songs: (json.songs as Json[]).map(songJSON => parseSong(songJSON)),
    programs: (json.programs as Json[]).map(programJSON => parseProgram(programJSON))
  }
}

export async function schedule (): Promise<Schedule> {
  let url: string
  if (mockBackend()) {
    url = '/mock-backend/program.json'
  } else {
    url = '/bm.prog_json.php'
  }
  const html = (await axios.get(url)).data
  return parseSchedule(html)
}
